export default {
  key: {
    marginLeft: 4
  }
}
